import { render, staticRenderFns } from "./OverlapSidebarMenu.vue?vue&type=template&id=fe739394&scoped=true&"
import script from "./OverlapSidebarMenu.vue?vue&type=script&lang=js&"
export * from "./OverlapSidebarMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe739394",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe739394')) {
      api.createRecord('fe739394', component.options)
    } else {
      api.reload('fe739394', component.options)
    }
    module.hot.accept("./OverlapSidebarMenu.vue?vue&type=template&id=fe739394&scoped=true&", function () {
      api.rerender('fe739394', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Sidebar/SidebarComponents/OverlapSidebarMenu.vue"
export default component.exports